const Link = {
   baseStyle: {
      color: 'brand.500',
      fontWeight: '600',
      _hover: {
         textDecoration: 'none',
      },
      _visited: {
         color: 'brand.500',
      },
   },
   defaultProps: {
      size: 'sm',
   },
   sizes: {
      sm: {
         fontSize: '14px',
      },
      md: {
         fontSize: '16px',
      },
      lg: {
         fontSize: '18px',
      },
   },
   variants: {
      underline: {
         textDecoration: 'underline',
         _hover: {
            textDecoration: 'underline',
         },
      },
   },
};

export default Link;
